<script setup>
import { router, usePage } from '@inertiajs/vue3'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const page = usePage()

const notification = computed(() => page.props.unreadReleaseNotification)
const visible = ref(false)

/**
 * Convert **bold** markdown to <strong> tags and preserve line breaks.
 * Escapes HTML first for safety.
 */
function formatSummary(text) {
  if (!text) return ''
  // Strip markdown heading prefixes (# Title)
  const clean = text.replace(/^#+\s+/gm, '')
  const escaped = clean.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>')
}

const formattedSummary = computed(() => formatSummary(notification.value?.summary))

watch(notification, (value) => {
  if (value) {
    visible.value = true
  }
}, { immediate: true })

async function dismiss() {
  if (notification.value?.id) {
    await fetch(`/api/notifications/${notification.value.id}/read`, {
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(
          document.cookie.match(/XSRF-TOKEN=([^;]+)/)?.[1] ?? ''
        ),
        'Accept': 'application/json',
      },
    })

    router.reload({ only: ['unreadReleaseNotification', 'unreadNotificationsCount'] })
  }

  visible.value = false
}
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :header="t('messages.releaseNotesTitle')"
    modal
    :closable="true"
    :style="{ width: '32rem' }"
    @hide="dismiss"
  >
    <div v-if="notification" class="space-y-3">
      <div v-if="notification.deployed_at" class="text-sm text-gray-500">
        {{ new Date(notification.deployed_at).toLocaleDateString('et-EE') }}
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="text-sm leading-relaxed text-gray-700" v-html="formattedSummary" />
    </div>

    <template #footer>
      <Button
        :label="t('messages.releaseNotesDismiss')"
        severity="primary"
        @click="dismiss"
      />
    </template>
  </Dialog>
</template>
